import Grid from "@mui/material/Grid2";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import React from "react";

function ChaseInvoicesLoading() {
  return (
    <Stack justifyContent="space-between" height="100%">
      <Grid container={true} spacing={2}>
        <Grid size={6}>
          <Skeleton height="30px" sx={{ transform: "none", marginBottom: "5px" }} />
          <Skeleton height="25px" sx={{ transform: "none" }} />
        </Grid>
        <Divider />
        <Grid size={12}>
          <Skeleton height="300px" sx={{ transform: "none" }} />
        </Grid>
      </Grid>
    </Stack>
  );
}

export default ChaseInvoicesLoading;
